import { DtoMetaAdsAccountData } from 'src/services/meta-ads/dto/dtoMetaAdsAccountData';

export function customerHasFacebookInstalled(
  data: DtoMetaAdsAccountData
): boolean {
  if (data?.fbe_installed) return true;

  return false;
}
